import React from 'react';
import { Redirect } from 'react-router';
import { getCommonRoutePath } from 'src/app/helpers/helpers';
export const HomeRedirect = () => {
    return React.createElement(Redirect, { to: `${getCommonRoutePath()}/home` });
};
